import { PlusCircleSVG } from 'common/assets';
import { Button } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import { SeparatorHorizontal, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import CruiseCard from './cruise-card';
import GuestCard from './guest-card';
import { addNewPurchase } from '../../hooks/use-get-default-values';
import { CruisePurchaseFormType } from '../form-type';

export default function CruiseSection() {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const { control, getValues } = useFormContext<CruisePurchaseFormType>();

  const fields = getValues('cruisePurchases');
  const { append, remove } = useFieldArray({
    control,
    name: 'cruisePurchases',
    keyName: '__customId',
  });

  const onAddCruisePurchase = React.useCallback(() => {
    append({
      ...addNewPurchase(),
      bookingCode: fields[0].bookingCode,
      cruiseId: fields[0].cruiseId,
      cruiseName: fields[0].cruiseName,
      cruiseShipId: fields[0].cruiseShipId,
      cruiseShipName: fields[0].cruiseShipName,
      reminder: fields[0].reminder,
      route: fields[0].route,
      endedAt: fields[0].endedAt,
      startedAt: fields[0].startedAt,
    });
  }, [append, fields]);

  const onRemoveCruisePurchase = React.useCallback(
    (index) => remove(index),
    [remove],
  );

  return (
    <div>
      <CruiseCard parentIndex={0} />
      <SeparatorVertical $margin={22}>
        <div style={{ height: 2 }} />
      </SeparatorVertical>

      {(fields || []).map((field, index) => (
        <React.Fragment key={field.customId}>
          <GuestCard
            parentIndex={index}
            onRemove={() => onRemoveCruisePurchase(index)}
            fieldLength={fields.length}
          />
          <SeparatorVertical $margin={22}>
            <div style={{ height: 2 }} />
          </SeparatorVertical>
        </React.Fragment>
      ))}
      {editable && (
        <>
          <SeparatorHorizontal $margin={16} />
          <Button
            startEnhancer={(color, size) => (
              <PlusCircleSVG color={color} size={size} />
            )}
            buttonType="secondary"
            onClick={onAddCruisePurchase}
          >
            {t('common:add')}
          </Button>
        </>
      )}
    </div>
  );
}
